import React from 'react';
import Modal from '../../UI/Modal/Modal';
import classes from './ProjectModal.module.css';

const ProjectModal = props => {
  const {
    color,
    imageSrc,
    title,
    tags,
    description,
    headline,
    link,
    fontColor,
    textShadow
  } = props.items;

  return (
    <Modal onClose={props.onClose} onColor={color}>
      <div onClick={props.onClose} className={classes.closebtn}>
        <ion-icon name="close"></ion-icon>
      </div>
      <section className={classes['modal-top']}>
        <div className={classes}>
          <img className={classes['modal-image']} src={imageSrc} alt="kaba" />
        </div>
        <h1 style={{ color: fontColor }} className={classes['modal-title']}>
          {title}
        </h1>
      </section>
      <section className={classes['modal-bottom']}>
        {/* <div className={classes.tags}>
          {tags.map((t, i) => (
            <div className={classes.tag} key={i}>
              {t}
            </div>
          ))}
        </div> */}
        <p
          style={{ color: fontColor }}
          className={classes['modal-description1']}
        >
          {headline}
        </p>
        <p
          style={{ color: fontColor, textShadow: textShadow }}
          className={classes['modal-description']}
        >
          {description}
        </p>
        <a
          href={link}
          target="_blank"
          rel="noreferrer"
          className={classes.link}
        >
          Visit Website{' '}
        </a>
      </section>
    </Modal>
  );
};

export default ProjectModal;
